import { useQuery } from '@tanstack/react-query';

export interface MetabaseFrame {
  iframeUrl: string;
  dashboard: string | number;
  aba?: string;
}

export interface MetabaseEmbedResponse {
  iframeUrl: string;
  arrIframes: MetabaseFrame[];
}

export function useMetabaseEmbed(idPassbook: string, enabled: boolean) {
  return useQuery({
    queryKey: ['dashboard', 'metabase', idPassbook],
    queryFn: async (): Promise<MetabaseEmbedResponse> => {
      const res = await fetch(`/bff/metabase/${idPassbook}`, { credentials: 'same-origin' });
      if (!res.ok) {
        const body = (await res.json().catch(() => ({}))) as { message?: string };
        throw new Error(body.message ?? 'Metabase indisponível');
      }
      return res.json() as Promise<MetabaseEmbedResponse>;
    },
    enabled,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
